<template>
    <div>
        <label class="relative inline-flex items-center cursor-pointer">
            <input
                type="checkbox"
                value=""
                class="sr-only peer"
                @change="(e) => toggleDebugMode(e.target.checked)"
            />
            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            <span class="ms-3 text-sm font-medium text-gray-100">Debug</span>
        </label>
    </div>
</template>

<script>
import {useDebugStore} from "../stores/debug";
import InputCheckbox from "./form/InputCheckbox.vue";

export default {
    name: "DebugMode",
    components: {InputCheckbox},
    data() {
        return {
            debugStore: useDebugStore(),
        };
    },
    methods: {
        toggleDebugMode (value) {
            this.debugStore.debugMode = value;
        },
    },
};
</script>

